var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fans-layout",attrs:{"id":"pageContent"}},[_c('TopBanner',{class:{mobile : _vm.isMobile && _vm.currentMenuName.includes('fansDetail')},attrs:{"bg-img":_vm.bgImg,"main-title":_vm.mainTitle,"sub-title":!_vm.isEmpty(_vm.subTitle) ? _vm.subTitle : _vm.routeName}}),_c('router-view',{staticClass:"contents"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }